import {TradeUtil} from "../../../../../js/util/TradeUtil";

export class Contract {

    private constructor(public readonly code: string,
                        public readonly underlying: string,
                        public readonly type: string | null,
                        public readonly style: string | null,
                        public readonly strike: number | null,
                        public readonly theo: number | null,
                        public readonly expiry: string | null,
                        public readonly delta: number | null,
                        public readonly cvf: number,
                        public readonly vol: number | null) {

    }

    // use function to prevent from serialization to API
    public isOption(): boolean {
        return this.code.length > 3;
    }

    public isEquity(): boolean {
        return !this.isOption();
    }

    public static from(position: Trade): Contract {
        if (TradeUtil.isEquity(position)) {
            return new Contract(position.underlyingCode,
                                position.underlyingCode,
                                null,
                                null,
                                null,
                                null,
                                null,
                                null,
                                position.cvf,
                                null);
        } else if (TradeUtil.isOption(position)) {
            return new Contract(position.code,
                                position.security,
                                position.type,
                                position.style,
                                position.strike,
                                position.theoPrice,
                                position.expiry,
                                position.delta,
                                position.cvf,
                                position.vol);
        } else {
            throw Error("Unknown Trade type");
        }
    }

    // Used to fake an Equity Contract for places expecting a Contract object still
    public static equityContract(code: string): Contract {
        return new Contract(code,
                            code,
                            "STOCK",
                            "N/A",
                            0,
                            0,
                            new Date(Number.MAX_SAFE_INTEGER).toDateString(),
                            0,
                            0,
                            0);
    }
}
